import { PartnerNotesData } from 'store/partnerNotes';
import { MobileNavItem } from '../MobileNav';
import { TrackEvent } from 'contexts/analytics/types';

type Props = {
  partnerNote: PartnerNotesData[string];
  showMembershipItem: boolean;
  isPartnerRecommendationNoteEnabled: boolean;
  trackEvent: TrackEvent;
};

export default function getNavItemParameters({
  partnerNote,
  showMembershipItem,
  isPartnerRecommendationNoteEnabled,
  trackEvent,
}: Props): Parameters<typeof MobileNavItem>[0] {
  if (partnerNote && isPartnerRecommendationNoteEnabled)
    return {
      pathname: `partner-recs/${partnerNote.partner.id}`,
      iconName: 'thumbStar',
      activeIconName: 'thumbStarFilled',
      label: `${partnerNote.partner.name} Recs`,
      iconClassName: 'partnerRecsIcon',
      onClick: () => trackEvent('Partner Recs Nav Clicked'),
    };

  if (showMembershipItem)
    return {
      pathname: 'membership',
      iconName: 'award',
      activeIconName: 'awardFilled',
      label: 'Tiny+',
      color: 'purple',
    };

  return {
    pathname: 'bookmarks',
    iconName: 'bookmark',
    activeIconName: 'bookmarkFilled',
    label: 'Bookmarks',
  };
}
